var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "4.5 4.5 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#6a6a6a",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 8.132 19.632)",
    fill: "rgba(255,255,255,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 11.5,
    rx: 12,
    ry: 11.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 11.5,
    rx: 11.35,
    ry: 10.85,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m21.507 11.727-9.91 9.91M11.596 11.727l9.911 9.91"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fe82df243d8f8e4b4c52b2b8b8c6863d.svg";
export { ForwardRef as ReactComponent };